import ApplicationAdapter from './application';

export default class FamilyAdapter extends ApplicationAdapter {
  urlForQuery(
    query: Record<string, unknown>,
    modelName: string | number
  ): string {
    if (query['catalog']) {
      delete query['catalog'];

      return `${super.urlForQuery(query, modelName)}/catalog`;
    }

    return super.urlForQuery(query, modelName);
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    family: FamilyAdapter;
  }
}
